// extracted by css-extract-rspack-plugin
export default {"container":"gBC9_","readonly":"XByU3","submitBtn":"XU7gL","active":"Cg9BH","content":"hqKqK","contentWrapper":"G7PXo","canSubmit":"lFlfl","bubbleMenu":"d09iN"};